import {
  type TypedUseSelectorHook,
  useSelector as useSelectorDefault,
  useDispatch as useDispatchDefault,
} from 'react-redux';
import {
  type AppDispatch as SettingsDispatch,
  type RootState as SettingsRootState,
} from '@app/settings-store';
import {
  type AppDispatch as WidgetDispatch,
  type RootState as WidgetRootState,
} from '@app/store/widget/widget-store';

export const useSettingsDispatch = () => useDispatchDefault<SettingsDispatch>();
export const useSettingsSelector: TypedUseSelectorHook<SettingsRootState> =
  useSelectorDefault;

export const useWidgetDispatch = () => useDispatchDefault<WidgetDispatch>();
export const useWidgetSelector: TypedUseSelectorHook<WidgetRootState> =
  useSelectorDefault;
